export const actionerList = [
	{
		photo: 'actioner-Alexander-Pharlenkov.png',
		name: 'Александр Фарленков',
		post: 'Основатель Credit.Club',
		experience: '',
	},
	{
		photo: 'actioner-Golodnov.png',
		name: 'Артём Голоднов',
		post: 'Финансовый директор ТАУ Индастриз',
		experience:
			'Директор по инвестициям Malltech\nВице-президент Goldman Sachs «Развивающиеся рынки»\nАудитор Ernst & Young',
	},
	// {
	// 	photo: 'actioner-Anton-Pharlenkov.jpg',
	// 	name: 'Антон Фарленков',
	// 	post: 'Член экспертного совета Banki.ru\nЧлен экспертного совета BestDoctor',
	// 	experience:
	// 		'Член правления Goldman Sachs Россия\n' +
	// 		"Директор по стратегии «О'КЕЙ Групп»\n" +
	// 		'Советник по коммерческим вопросам на Северном море в Royal Dutch Shell',
	// },
	{
		photo: 'actioner-Mironenkov.png',
		name: 'Антон Мироненков',
		post: 'Член правления и управляющий директор Х5 Технологии',
		experience: 'X5 Retail Group\nPricewaterhouseCoopers — PwC',
	},
	{
		photo: 'actioner-Arabidi.png',
		name: 'Константин Арабидис',
		post: "Финансовый директор «О'КЕЙ Групп»",
		experience: 'Аудитор PricewaterhouseCoopers — PwC',
	},
]

export const companyList = [
	'winter-capital.png',
	'TAU.png',
	'retail-group.png',
	'ok-group.png',
	'banki.png',
	'skyeng.png',
]
